export default class WayPointData {
    constructor(latitude, longitude, position, type) {
        this.latitude = latitude,
            this.longitude = longitude,
            this.position = position,
            this.type = type
    }
}